<template>
  <div class="content">
<!--    <iframe v-if="isusersession=='nosession'" id="pluginonlin" name="pluginonlin"-->
<!--            :src="`https://tool.5118.com/Pluginonline`"-->
<!--            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
<!--    <iframe v-if="isuseruserinfo=='nosession'" id="pluginonlin" name="pluginonlin"-->
<!--            :src="`https://tool.5118.com/Pluginonline`"-->
<!--            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
<!--    <iframe v-if="isplken=='nosession'" id="pluginonlin" name="pluginonlin"-->
<!--            :src="`https://tool.5118.com/Pluginonline`"-->
<!--            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
    <iframe v-if="logged" id="onlinetongji" name="onlinetongji"
            :src="`https://aiplugin.5118.com/Pluginstat/?p=UserOnline`"
            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>
    <div class="header">
      <span class="title">{{keywords}}</span>
      <span>-</span>
      <span>SEO难度报告</span>
      <span style="float: right;margin-top: 1px;"><img src="../assets/image/seo-logo.png"></span>
    </div>
    <div class="body">
      <table class="table">
        <thead>
        <tr>
          <th>长尾词个数</th>
          <th>相关词个数</th>
          <th>百度指数</th>
          <th>搜索结果量</th>
          <th>发现竞价公司</th>
          <th>竞价激烈度</th>
        </tr>
        </thead>
        <tbody>
        <tr style="cursor: pointer;">
          <td @click="jump_url(1)">{{longcount}}</td>
          <td @click="jump_url(2)">{{relatedcount}}</td>
          <td @click="jump_url(1)">{{baiduindex}}</td>
          <td @click="jump_url(1)">{{baiduresults}}</td>
          <td @click="jump_url(3)">{{semcompanycount}}</td>
          <td @click="jump_url(1)">{{semkwc}}<progress max="50" :value="semkwc" ></progress></td>
        </tr>

        </tbody>
      </table>
      <p style="line-height: 40px;color: #666;font-size: 14px">当前页面排名网站分布</p>
      <table class="table">
        <thead>
        <tr>
          <th style="background-color: #2d7dff;color:white">百科</th>
          <th style="background-color: #2d7dff;color:white">知道</th>
          <th style="background-color: #2d7dff;color:white">百度系</th>
          <th style="background-color: #00c;color:white">网站首页</th>
          <th style="background-color: red;color:white">大型网站内页</th>
          <th style="background-color: #7cd86b;color:white">小型网站内页</th>
        </tr>
        </thead>
        <tbody>
        <tr >
          <td style="color: #666">{{isbaikenum}}个</td>
          <td style="color: #666">{{iszhidaonum}}个</td>
          <td style="color: #666">{{istoutiaonum}}个</td>
          <td style="color: #666">{{isindexcount}}个</td>
          <td style="color: #666">{{bigweb}}个</td>
          <td style="color: #666">{{middleweb}}个</td>
        </tr>

        </tbody>
      </table>
      <ul class="tab" style="margin-top: 20px">
        <li class="tab-item active">
          {{pageindex}}-{{pagenumber}}排名
        </li>
        <!--<li class="tab-item" :class="{active:!nthTen}" @click="nthTen = false">-->
          <!--11-20排名-->
        <!--</li>-->
      </ul>
      <ul class="row" style="margin-top: 10px;display:block;">
        <li v-for="(item,index) in baiduranklist" :key="index" class="col-6" style="margin-bottom: 2px">
          <div @click="jump_seo_url(item.domain)" :title="item.allurl" style="padding: 5px;margin: 0 1px;line-height: 25px;font-size: 12px;color: white;cursor: pointer;" class="ellipsis" :style="{backgroundColor:getColor(item.domain,item.weight,item.index)}">
            <template >
              {{item.title}}
            </template>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  // import axios  from 'axios'
  export default {
    data: function () {
      return {
        bigweb:0,
        iszhidaonum:0,
        isbaikenum:0,
        istoutiaonum:0,
        isindexcount:0,
        middleweb:0,
        longcount:0,
        relatedcount:0,
        baiduindex:0,
        baiduresults:0,
        semcompanycount:0,
        semkwc:0,
        keywords:'',
        baiduranklist:[],
        nthTen:true,
        pageindex:0,
        pagenumber:0,
        isusersession:"",
        isuseruserinfo:"",
        isplken:""
      }
    },
    computed: {
      logged: {
        get() {
          return this.$store.state.user.logged
        },set(val){
          this.$store.state.user.logged = val
        }
      }
    },
    mounted() {
      this.$messenger.addTarget(window.parent, 'parent');
      this.$messenger.targets['parent'].send("BaiDu_Rank_BdDiff_Check");
      this.get_user_data();
      this.listen();
      this.get_userinfo_coookies();
    },
    methods: {
      listen(){
        this.$bddiffmessageer.listen("_5118_Baidu_Seo_Keywords", (msg) => {
          // console.log(msg);
          this.keywords=msg.keywords;
          this.longcount=msg.longcount;
          this.relatedcount=msg.relatedcount;
          this.baiduindex=msg.baiduindex==-1?'暂无':msg.baiduindex;
          this.baiduresults=msg.baiduresults;
          this.semcompanycount=msg.semcompanycount;
          this.semkwc=msg.semkwc;

        });

        this.$bddiffmessageer.listen("_5118_Baidu_Seo_Rank_Info", (msg) => {
          this.bigweb=msg[0].bigweb;
          this.iszhidaonum=msg[0].iszhidaonum;
          this.isbaikenum=msg[0].isbaikenum;
          this.istoutiaonum=msg[0].istoutiaonum;
          this.isindexcount=msg[0].isindexcount;
          this.middleweb=msg[0].middleweb;
          this.baiduranklist=msg[1].sort((a, b) => a.id-b.id);
          this.pageindex=msg[0].pageindex;
          this.pagenumber=msg[0].pagenumber;
          // console.log(this.baiduranklist);
        });

        this.$bddiffmessageer.listen("_5118_Check_Add_Login_Num", (msg) => {

          // _hmt.push(['_trackEvent', 'Login', 'JumpLogin']);
        });

        this.$bddiffmessageer.listen("_5118_Check_IsLogin_Status", (msg) => {
          if(this.logged){
            this.$messenger.addTarget(window.parent, 'parent');
            this.$messenger.targets['parent'].send("Show_Login_Baidu_Message","1");
          }
          else
          {
            this.$messenger.addTarget(window.parent, 'parent');
            this.$messenger.targets['parent'].send("Show_Login_Baidu_Message","2");
          }
        });
      },
      jump_url(num){
        if(num==1)window.open('https://www.5118.com/seo/newwords/'+this.keywords.encodeUnicode() +'?f=plugin');
        if(num==2)window.open('https://www.5118.com/seo/newrelated/'+this.keywords +'?f=plugin');
        if(num==3)window.open('https://www.5118.com/seo/bidsite/'+this.keywords +'?f=plugin');
      },
      jump_seo_url(url){
        if(url!="加载中")window.open('https://seo.5118.com/'+url +'?f=plugin');
      },
      getColor(name,weight,index){
        weight = weight* 1
        if(name ==="加载中"){
          return "#aaa"
        }else{
          if(name.indexOf(".baidu.com" )!==-1){
          return "#2b77fd"
        }else{
          if(index==1)
          {
            return "rgb(0, 0, 204)"
          } else if(weight>=5){
            return "red"
          }else if(weight<=2){
            return "#7cd86b"
          }else{
            return "#37b61f"
          }
        }
        }
      },
      get_userinfo_coookies() {
        let userInfo = JSON.parse(Cookies.get('_5118_Plug_In_UserInfo')||"{}") || {};
        this.logged = !!userInfo.avatar;
        if(userInfo){
          if(userInfo.plken){
            this.isplken = this.apitoken
          }
          else{
            this.isplken="nosession"
          }
        }
        if(this.isusersession!="nosession")this.isuseruserinfo = userInfo.uid || "nosession";
      },
      get_user_data(){
        this.isusersession = Cookies.get('_5118_Plug_In_Session') || "nosession";
      },
      // testdata(){
      //   axios.get("https://tool.5118.com/api/BrowserPlugInMessage")
      //   .then(response => {
      //     console.log(response.data)
      //     })
      // }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  @baidu-size: 540px;
  .content {
    border: 2px solid @theme-color;
    width: @baidu-size;
    box-shadow: 0 2px 6px rgba(0,0,0,.2);
    .header {
      line-height: 35px;
      font-size: 16px;
      padding: 0px 2px 0px 15px;
      background-color: #e8efff;
      .title {
        color: @theme-color;
      }
    }
    .body {
      padding: 10px;
      .table {
        width: 100%;
        border-collapse: collapse;
        text-align: center;
        border: 1px solid rgb(230, 230, 230);
        border-image: initial;
        table-layout: fixed;
        th {
          font-size: 12px;
          font-weight: 500;
          line-height: 30px;
          text-align: center;
          vertical-align: middle;
          padding: 0;
          border: 1px solid rgb(239, 239, 239);
          border-image: initial;
          color: #666;
        }
        td {
          font-size: 12px;
          text-align: center;
          vertical-align: middle;
          padding: 5px 0;
          border: 1px solid rgb(239, 239, 239);
          border-image: initial;
          color: @theme-color;
        }
      }

      .tab {
        border-bottom: 1px solid #ccc;
        .tab-item {
          display: inline-block;
          color: #666;
          line-height: 25px;
          padding: 0 1em;
          font-size: 14px;
          cursor: pointer;
          background-color: white;
          margin: 0;
          &.active {
            border: 1px solid #cccccc;
            border-bottom-style: none;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            color: @theme-color;
            position: relative;
            bottom: -1px;
          }
        }
      }
    }

    progress{
      display: inline-block;
      width: 50px;
      height: 8px;
      margin-left: 5px;
      background-color: #f0f0f0;
      vertical-align: middle;
      &::-webkit-progress-bar {
        background-color: #f0f0f0;
      }
      color: @theme-color;
      &::-webkit-progress-value {
        background-color: @theme-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Difficulty.vue